export enum SearchReturnType {
  Subject = 'subject',
  Session = 'session',
  Acquisition = 'acquisition',
  File = 'file',
  Analysis = 'analysis',
}

export interface SearchQuery {
  all_data: boolean
  filters: SearchFilter[]
  return_type: SearchReturnType
  search_string?: string
  structured_query?: string
}

export interface SearchFilter {
  match?: {
    [field: string]: string
  }
  term?: {
    [field: string]: string
  }
  terms?: {
    [field: string]: string[]
  }
  range?: {
    [field: string]: {
      gte?: number | string
      lte?: number | string
    }
  }
}
